import { mapState } from 'vuex';
import get from 'lodash/get';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { isCopyToClipboardSupported, copyToClipboard } from '@/utils/vuex';
import { localizeDate } from '@/utils/date';
export default {
  name: 'NiotaClassicDevicesListsPacketList',
  props: {
    items: {
      type: Array,
      required: true
    },
    datasourceType: {
      type: String,
      required: true
    },
    switchDate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      expanded: false,
      packets: [],
      opened: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color', 'permissions', 'language']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    items() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  created() {
    setInterval(() => {
      this.packets = this.packets.map(packet => {
        moment.locale(this.language);
        packet.ago = moment(packet.source_time).fromNow();
        return packet;
      });
    }, 1000);
  },
  methods: {
    get,
    initData() {
      if (this.items) {
        this.packets = cloneDeep(this.items);
      }
    },
    clickedUserTableRow(item) {
      const index = this.opened.indexOf(item.uid);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(item.uid);
      }
    },
    isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard(event, data) {
      let copyValue = '';
      if (typeof data === 'object' && data !== null) {
        copyValue = JSON.stringify(data);
      } else if (typeof data === 'string') {
        copyValue = data;
      }
      event.stopPropagation();
      copyToClipboard(copyValue);
    },
    getLink(type, item) {
      let latitude = 0;
      let longitude = 0;
      if (type === 'ACTILITY') {
        latitude = get(item, 'source_data.LrrLAT');
        longitude = get(item, 'source_data.LrrLON');
      } else if (type === 'FIREFLY_MQTT' && get(item, 'source_data.parsed')) {
        latitude = get(item, 'source_data.parsed.gps.latitude');
        longitude = get(item, 'source_data.parsed.gps.longitude');
      }
      return `https://www.google.com/maps/place/${latitude}+${longitude}/@${latitude},${longitude},15z`;
    },
    gmsLink(gweui) {
      return `https://gms.fireflyiot.com/gateway/details/${gweui}`;
    },
    localizeDate(item) {
      return localizeDate(item);
    }
  }
};